import React from "react";
import pdfFile from "../pdfs/Tipkit-BelldeskGuide-english.pdf";
import PdfViewer from "../comman/PdfViewer";
import { onboardingDocs } from "../consfig";

const BellStaffGuideEnglish = () => {
  const pdfUrl = onboardingDocs.b2c.belldesk;
  return <PdfViewer pdfFile={pdfUrl} />;
};

export default BellStaffGuideEnglish;
